import {Button, Modal} from "react-bootstrap";
import ImageComponent from "../shared/ImageComponent";
import {baseImageUrl} from "../../../services/AxiosInstance";
import profileImage from "../../../images/profileImage.png";
import {Field, Formik} from "formik";
import * as Yup from "yup";
import {useAddReview} from "../../../hooks/useReview";
import {useAddTicket} from "../../../hooks/useTicket";
import {useUpdateIntervention} from "../../../hooks/useInterventions";
import {interventionStatus, userRoleList} from "../../../utils/constants";
import {useNavigate} from "react-router-dom";
import {chatApi} from "../../../services/ChatService";

const RefuseModal = ({openModal, toggleModal, intervention, role}) => {
  const {onUpdateIntervention} = useUpdateIntervention();
  const navigate = useNavigate();

  const handleContact = async () => {
    if (!intervention?.Offer_Proposal?.Offer) {
      navigate(
        "/messages#" + intervention?.Offer_Proposal?.directChat?.chatroomId
      );
    } else {
      const response = await chatApi.getAll({
        filter: {
          clientId: intervention?.Offer_Proposal?.Offer?.clientId,
          offerId: intervention?.Offer_Proposal?.Offer?.id,
          technicianId: intervention?.Offer_Proposal?.Technician?.id,
        },
      });
      if (response) {
        navigate("/messages#" + response?.rows[0]?.id);
      }
    }
  };
  const handleSubmit = async () => {
    // Add your review submission logic here
    await onUpdateIntervention({
      id: intervention?.id,
      body: {
        status: interventionStatus.CANCELED,
        cancellationReason: "refuser nouvelle rdv",
      },
    });
    toggleModal(false);
  };
  return (
    <Modal
      className="modal fade"
      show={openModal}
      onHide={toggleModal}
      centered
      size="md"
    >
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title text-[#1A64B9] font-semibold">
            Annuler l'intervention
          </h4>
          <Button
            variant=""
            type="button"
            className="close"
            onClick={() => toggleModal(false)}
          >
            <span>×</span>
          </Button>
        </div>
        <div className="modal-body !py-3 !px-0 h-fit max-h-[70vh] overflow-scroll overflow-style-none">
          <div className="w-full flex flex-col justify-center items-center gap-2 ">
            <div className="flex flex-col justify-center items-center ">
              <div
                className="text-base font-normal !px-6  text-[#19295C]
                text-center
                "
              >
                Veuillez contacter le{" "}
                {role === userRoleList.TECHNICIAN ? "client" : "prestataire"}{" "}
                pour arranger une nouvelle date plus convenable ou annuler
                l'intervention{" "}
              </div>
            </div>

            <div className="w-full !px-6 !py-3">
              <div className="grid grid-cols-2 gap-2 mt-4">
                <button
                  type="button"
                  onClick={() => handleSubmit()}
                  className="!rounded-md  !py-3 bg-white !text-[#0D44B1] !border-[#0D44B1] !border font-medium text-sm   uppercase"
                >
                  Annuler l'intervention
                </button>

                <button
                  onClick={() => handleContact()}
                  type="button"
                  className="!rounded-md  !py-3 text-white bg-gradient-to-r from-[#0022AA] to-[#1A64B9] font-medium text-sm    uppercase"
                >
                  Contacter le{" "}
                  {role === userRoleList.TECHNICIAN ? "client" : "prestataire"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default RefuseModal;
